import UserDetailsPage from "components/pages/UserDetailsPage";

/**
 * @name CaptureAddUser
 * @returns {React.Component}
 * @description 
 */
export default function CaptureAddUser(props) {
    return <UserDetailsPage/>;
}